import { graticoBot } from "./gratico/index";

export const bots = [graticoBot];
